import { render } from "./IconInvestedRoundedType9.vue?vue&type=template&id=3d6b64ff&ts=true"
import script from "./IconInvestedRoundedType9.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType9.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__